export const createSiteGroupForm = () => ({
  sites: [],
  siteGroup: null,
})
